let width: Ref<number> = ref(0)
let height: Ref<number> = ref(0)
let pixelRatio: number = 1

export default function useSizes() {
  if (process.client) {
    width.value =
      document.getElementById('canvasContainerRef')?.clientWidth ||
      window.innerWidth
    height.value =
      document.getElementById('canvasContainerRef')?.clientHeight ||
      window.innerHeight
    pixelRatio = Math.min(window.devicePixelRatio, 2)

    window.addEventListener('resize', () => {
      resize(
        document.getElementById('canvasContainerRef')?.clientWidth,
        document.getElementById('canvasContainerRef')?.clientHeight
      )
    })
  }

  function resize(_width?: number, _height?: number) {
    width.value = _width || window.innerWidth
    height.value = _height || window.innerHeight
    pixelRatio = Math.min(window.devicePixelRatio, 2)
  }

  return {
    width,
    height,
    pixelRatio,
    resize,
  }
}
